module.exports = __webpack_public_path__ + "img/cgitchartdefault.8df7476f.jpg";